import { styled } from "styled-components";

export const ReviewInfo = styled.div`
  margin-left: 30px;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
`;
